export default {
  each(items, eachFn) {
    if (!items) return;

    for (let index = 0; index < items.length; index++)
      eachFn(items[index], index);
  },

  find(items, eachFn) {
    if (!items) return null;

    for (let index = 0; index < items.length; index++)
      if (eachFn(items[index], index)) return items[index];

    return null;
  },

  //đừng dùng hàm này nữa, dùng hàm indexOf nhé;
  index(items, item, compareFn) {
    if (!items) return -1;

    for (let index = 0; index < items.length; index++)
      if (compareFn(items[index], item)) return index;

    return -1;
  },

  indexOf(items, compareFn) {
    if (!items) return -1;
    for (let index = 0; index < items.length; index++)
      if (compareFn(items[index], index)) return index;
    return -1;
  },

  exists(items, compareFn) {
    return this.indexOf(items, compareFn) !== -1;
  },

  findAll(items, eachFn) {
    if (!items) return null;

    let arr = [];

    for (let index = 0; index < items.length; index++)
      if (eachFn(items[index], index)) arr.push(items[index]);

    return arr;
  },

  count(items, eachFn) {
    let count = 0;
    if (!items) return count;

    for (let index = 0; index < items.length; index++)
      if (eachFn(items[index], index)) count++;

    return count;
  },

  collect(items, eachFn) {
    if (!items) return null;

    let arr = [];

    for (let index = 0; index < items.length; index++)
      arr.push(eachFn(items[index], index));

    return arr;
  },

  sum(items, eachFn) {
    if (!items) return 0;

    let sum = 0;

    for (let index = 0; index < items.length; index++)
      sum += eachFn(items[index], index);

    return sum;
  },

  max(items, compareFn) {
    if (!items && !items.length) return null;

    let maxItem = items[0];

    for (let index = 1; index < items.length; index++)
      if (compareFn(maxItem, items[index]) < 0) maxItem = items[index];

    return maxItem;
  },

  group(items, groupByFn, groupLabel) {
    !groupLabel && (groupLabel = groupByFn);

    let groupKeys = [];
    let groups = [];

    this.each(items, item => {
      let groupKey = groupByFn(item);
      let index = groupKeys.indexOf(groupKey);
      if (index == -1) {
        groupKeys.push(groupKey);
        groups.push({groupKey: groupLabel(item), items: [item]});
      } else {
        groups[index].items.push(item);
      }
    });

    return groups;
  },
};



// WEBPACK FOOTER //
// ./src/services/h.js